import { shouldPolyfill as shouldPolyfillLocale } from '@formatjs/intl-locale/should-polyfill.js';
import { shouldPolyfill as shouldPolyfillPlural } from '@formatjs/intl-pluralrules/should-polyfill.js';

function should() {
    return (
        typeof window.Intl === 'undefined' ||
        shouldPolyfillLocale() ||
        shouldPolyfillPlural() ||
        typeof window.IntersectionObserver === 'undefined' ||
        typeof window.ResizeObserver === 'undefined'
    );
}

export default should;
